export default {
    project_name: "Samsung SDS Academy",
    register: "GEN",
    document: "GEN"
}